'use client';

import React from 'react';
import { useAdsense } from '../../../hooks/useAdsense';
import { BelowTitleAd, FirstParagraphAd, MidContentAd, EndContentAd, SideAd, StickyMobileAd } from '../AdPlacement';

/**
 * Example implementation of an article page with optimized ad placements
 * This shows how to integrate the new ad system into content pages
 */
export default function ArticleWithAds({ title, content, children }) {
  const { showAds, isMobile } = useAdsense();
  
  // Split content into paragraphs for ad insertion
  const paragraphs = React.Children.toArray(children);
  const midPoint = Math.floor(paragraphs.length / 2);
  
  return (
    <div className="w-full flex flex-col lg:flex-row gap-6">
      {/* Main content column */}
      <div className="flex-1">
        {/* Title section */}
        <h1 className="text-3xl font-bold mb-4">{title}</h1>
        
        {/* Below title ad - high CTR zone */}
        {showAds && <BelowTitleAd />}
        
        {/* First part of content */}
        {paragraphs.slice(0, 2)}
        
        {/* First paragraph ad */}
        {showAds && paragraphs.length > 4 && <FirstParagraphAd />}
        
        {/* Middle part of content */}
        {paragraphs.slice(2, midPoint)}
        
        {/* Mid-content ad for longer articles */}
        {showAds && paragraphs.length > 8 && <MidContentAd />}
        
        {/* Remaining content */}
        {paragraphs.slice(midPoint)}
        
        {/* End of content ad */}
        {showAds && <EndContentAd />}
      </div>
      
      {/* Sidebar - only on desktop */}
      {showAds && !isMobile && (
        <div className="w-[300px] hidden lg:block">
          <SideAd />
        </div>
      )}
      
      {/* Mobile sticky ad - only shows on mobile */}
      {showAds && isMobile && <StickyMobileAd />}
    </div>
  );
}
